////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { map } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'
/////////ASSETS/////////
import ArrowUp from '../../../../../assets/icones/global/arrow-up.svg'
import ArrowDown from '../../../../../assets/icones/global/arrow-down.svg'

/////////STYLED/////////
const PaperWrapper = styled.div`
	position: absolute;
    display: grid;
    grid-template-columns: max-content;
    grid-auto-rows: 40px;
    justify-content: stretch;
    align-items: stretch;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    padding: 0 20px;
    top: 40px;
    right: 0;
    z-index: 51;
    overflow-y: auto;
	max-height:${(props) => `${props.height}px`};
	::-webkit-scrollbar {
		width: 17px;
		height: 18px;
	}
	::-webkit-scrollbar-thumb {
		height: 6px;
		border-right: 10px solid rgba(0, 0, 0, 0);
		border-left:${(props) => props.theme.colors.backgroundScroll};
		border-top:${(props) => props.theme.colors.backgroundScroll},
		border-bottom:${(props) => props.theme.colors.backgroundScroll};
		background-clip: padding-box;
		background-color: ${(props) => props.theme.colors.eraser};
	
	}
	::-webkit-scrollbar-button:vertical:decrement:single-button {
		background: no-repeat${(props) => props.theme.colors.backgroundScroll};
		background-image: url(${ArrowUp});
		height:10px;
		background-position: center bottom;
		border-right: 10px solid white;

	}
	::-webkit-scrollbar-button:vertical:increment:single-button {
		background: no-repeat${(props) => props.theme.colors.backgroundScroll};
		background-image: url(${ArrowDown});
		height:10px;
		background-position: center bottom;
		border-right: 10px solid white;	
	}
	::-webkit-scrollbar-track-piece{
		background-color: ${(props) => props.theme.colors.backgroundScroll};
		border-right: 10px solid white;
	}
`
const ListWrapper = styled.label`
	display: grid;
	grid-template-columns: min-content max-content;
	grid-column-gap: 10px;
	justify-content: start;
	align-items: center;
	cursor: pointer;
`
const PaperList = styled.span`
	cursor: pointer;
`
const PaperCheckbox = styled.input`
	cursor: pointer;
`
//////STYLED//////

const Paper = ({ showPaper, columns, setColumns }) => {
	const { height } = useSelector(
		(state) => ({
			height: state.columns.height,
		}),
		shallowEqual
	)
	return (
		showPaper && (
			<PaperWrapper height={height}>
				{map(
					columns,
					(column, id) =>
						!column.action && (
							<ListWrapper key={id}>
								{/*//list*/}
								<PaperCheckbox
									onChange={() => setColumns(id, column.columnReferential)}
									checked={column.visibility}
									type="checkbox"
								/>
								<PaperList>{column.headerName}</PaperList>
							</ListWrapper>
						)
				)}
			</PaperWrapper>
		)
	)
}

Paper.propTypes = {}

Paper.defaultPropTypes = {}

export default Paper
